export default {
    department: '部门',
    expert: '专家',
    lecturer: '讲师',
    reply: '回复',
    noData: '没有数据',
    hour: '时',
    minute: '分',
    minutes: '分钟',
    years: '年',
    months: '月',
    day: '日',
    position: '岗位',
    download: '下载',
    ext_code: '二维码.png',
    lecture: '讲师',
    score_one_star: '1星',
    score_two_star: '2星',
    score_three_star: '3星',
    score_four_star: '4星',
    score_five_star: '5星',
    score_no: '暂无评分',
    score_do_score: '我来评分',
    score_submission: '提交评分',
    share_curriculum: '课程',
    share_learning_path: '学习路径',
    share_knowledge: '知识',
    share_class: '培训班',
    share_investigation_and_research: '调研',
    share_micro_class_contest: '微课大赛',
    share_examination: '考试',
    share_special: '专题',
    share_live_broadcast: '直播',
    share_discuss: '讨论',
    share_content: '内容',
    share_sharing: '分享',
    share_the_wechat: '分享到微信',
    share_the_qq_space: '分享到QQ空间',
    share_sina_micro_blog: '分享到新浪微博',
    share_the_question: '分享到问吧',
    operation_success: '操作成功',
    operation: {
        title: '总体运营',
        boardName: '大数据看板',
        totalVisit: '累计访问次数',
    },
};
